import React from 'react';

import { itemHasContent } from '../../../../../data/filters/directory/itemHasContent';
import { useDirectoryItemContacts } from '../../../../../data/hooks/directory/directoryHooks';
import Icon from '../../../../elements/icons/Icon';
import Link from '../../../../elements/Link';
import ListItem from '../../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../../elements/ListItem/ListItemContent';
import { ListItemImage } from '../../../../elements/ListItem/ListItemImage';
import RightChevron from '../../../../elements/RightChevron/RightChevron';
import stylesheet from './DirectoryListItem.module.scss';

const DirectoryListItem = (props) => {
    const { className = '', event, item, href: itemHref, onClick } = props,
        contacts = useDirectoryItemContacts(event.id, item.id),
        hasContent = itemHasContent(item) || contacts.length,
        href = itemHref !== undefined ? itemHref : hasContent ? ['.', item.id].join('/') : null,
        liClasses = [className, 'whitebg', hasContent ? 'clickable' : ''],
        { is_favorite } = item;

    return (
        <ListItem className={liClasses.join(' ')}>
            <Icon className={[stylesheet.favorite, is_favorite ? stylesheet.active : ''].join(' ')} />
            <ListItemContent href={href} onClick={onClick}>
                <h3 className="name">{item.name}</h3>
                <div className="location">{item.location}</div>
            </ListItemContent>
            {item.image_url ? (
                <Link href={href} onClick={onClick} className={stylesheet.image}>
                    <ListItemImage src={item.image_url} />
                </Link>
            ) : null}
            <RightChevron style={{ visibility: href || onClick ? 'visible' : 'hidden' }} />
        </ListItem>
    );
};

export default DirectoryListItem;
